import React, { useState } from 'react';
import { Download } from 'lucide-react';

const TermsAndConditions = () => {
  const [terms, setTerms] = useState(
    "These are the current terms and conditions. You can edit and update them as needed."
  );
  const [isEditing, setIsEditing] = useState(false);

  // Handle input changes
  const handleInputChange = (e) => {
    setTerms(e.target.value);
  };

  // Toggle edit mode
  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  // Save terms (dummy action for now)
  const saveTerms = () => {
    console.log('Terms saved:', terms);
    setIsEditing(false);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ textAlign: 'center' }}>Manage Terms and Conditions</h1>
      
      <div style={{ margin: '20px 0', padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }}>
        {isEditing ? (
          <textarea
            value={terms}
            onChange={handleInputChange}
            rows="10"
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '16px',
              border: '1px solid #ddd',
              borderRadius: '5px',
            }}
          ></textarea>
        ) : (
          <div style={{ whiteSpace: 'pre-wrap', fontSize: '16px', lineHeight: '1.5' }}>
            {terms}
          </div>
        )}
      </div>
      
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        {isEditing ? (
          <>
            <button
              onClick={saveTerms}
              style={{
                padding: '10px 20px',
                margin: '5px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Save
            </button>
            <button
              onClick={toggleEdit}
              style={{
                padding: '10px 20px',
                margin: '5px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Cancel
            </button>
          </>
        ) : (
          <button
            onClick={toggleEdit}
            style={{
              padding: '10px 20px',
              backgroundColor: '#2196F3',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
          >
            Edit Terms
          </button>
        )}
      </div>

      {/* Download User Manual Section */}
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <h3 style={{ marginBottom: '10px', color: '#333' }}>Download User Manual</h3>
        <a
          href="/public/assets/MZWUserManual.docx"
          download
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            padding: '10px 20px',
            backgroundColor: '#ff9800',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '5px',
            fontSize: '16px',
            fontWeight: 'bold',
          }}
        >
          <Download size={20} style={{ marginRight: '8px' }} />
          Download User Manual
        </a>
      </div>
    </div>
  );
};

export default TermsAndConditions;
